import { makeStyles, tokens } from '@fluentui/react-components';
import { fontScale } from '@/theme';

export const useNavItemStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '0.125rem',
    paddingLeft: tokens.spacingHorizontalXS,
    paddingRight: tokens.spacingHorizontalXS,
    cursor: 'pointer',
    boxSizing: 'border-box',
    borderRadius: tokens.borderRadiusSmall,
    ':hover': {
      backgroundColor: tokens.colorNeutralBackground3Hover,
    },
  },
  button: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: tokens.spacingHorizontalS,
    paddingTop: tokens.spacingVerticalS,
    paddingBottom: tokens.spacingVerticalS,
    paddingLeft: tokens.spacingHorizontalS,
    paddingRight: tokens.spacingHorizontalSNudge,
    borderRadius: tokens.borderRadiusSmall,
    flex: 1,
    border: 'none',
    backgroundColor: 'inherit',
    ':focus-visible': {
      outlineStyle: 'solid',
      outlineWidth: '0.125rem',
      outlineColor: tokens.colorStrokeFocus2,
      outlineOffset: '-2px',
    },
  },
  indicator: {
    width: '0.25rem',
    height: '1.25rem',
    borderRadius: tokens.borderRadiusSmall,
    flexShrink: 0,
    backgroundColor: 'transparent',
  },
  indicatorSelected: {
    backgroundColor: tokens.colorBrandBackground,
  },
  icon: {
    width: '1.25rem',
    height: '1.25rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: tokens.colorNeutralForeground2,
    flexShrink: 0,
  },
  iconSelected: {
    color: tokens.colorNeutralForeground1,
  },
  label: {
    fontSize: fontScale.body,
    lineHeight: tokens.lineHeightBase300,
    fontWeight: tokens.fontWeightRegular,
    color: tokens.colorNeutralForeground2,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  labelSelected: {
    fontWeight: tokens.fontWeightSemibold,
    color: tokens.colorNeutralForeground1,
  },
});
